import { render, staticRenderFns } from "./AdminEmptyState.vue?vue&type=template&id=37aa728c&scoped=true&"
import script from "./AdminEmptyState.vue?vue&type=script&lang=js&"
export * from "./AdminEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./AdminEmptyState.vue?vue&type=style&index=0&id=37aa728c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa728c",
  null
  
)

export default component.exports